/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Announced } from '@fluentui/react/lib/Announced';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';

export type SearchResultsAnnouncerProps = {
    /**
     * The number of items to be announced.
     */
    itemsLength: number;

    /**
     * Indicates whether text should announced or not.
     */
    isActive?: boolean;
};

const messages = defineMessages({
    announcedMessage: {
        id: 'core.searchResultsAnnouncer.announcedMessage',
        defaultMessage: '{itemsLength} items found'
    }
});

/**
 * A thin component announce the number of result items after applying the search operation
 * used for the accessibility.
 */
export const SearchResultsAnnouncer = (props: SearchResultsAnnouncerProps) => {
    const { itemsLength, isActive = false } = props;
    const { localize } = useLocalization();

    const activate = React.useCallback(() => isActive, [isActive]);

    return activate && <Announced message={localize(messages.announcedMessage, { itemsLength })} />;
};
